export default __webpack_public_path__ + "static/media/MissionEllisMobile.221e4efd.png";